import { useInfiniteQuery } from '@tanstack/react-query';
import { GetSearchProductsQuery } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { GetSearchProductsResponse } from '@winelivery-org/wl-client-sdk-js/src/models/search/product';
import { getStoreProducts } from '@/services/search';

export function getFindManyProductsQueryOptions(
  filters: Omit<GetSearchProductsQuery, 'deliveryType'> & {
    deliveryType?: string;
  },
) {
  return {
    queryKey: ['products', filters],
    queryFn: ({ pageParam }) =>
      getStoreProducts({
        ...filters,
        page: pageParam,
      }),
    staleTime: 0,
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      const fetched = pages.reduce((acc, curr) => acc + curr.items.length, 0);
      if (lastPage.count > fetched) {
        return pages.length + 1;
      }
    },
  };
}

export default function useFindManyProductsQuery(
  filters: Omit<GetSearchProductsQuery, 'deliveryType'> & {
    deliveryType?: string;
  },
) {
  return useInfiniteQuery<GetSearchProductsResponse>(
    getFindManyProductsQueryOptions(filters),
  );
}
